<!-- @format -->

<template>
	<el-select
		v-model="checkIds"
		:multiple="multiple"
		:teleported="false"
		placeholder="请选择"
		v-bind="$attrs"
		@remove-tag="(e) => onDelete(e)"
		@change="(e) => onSelect(e)"
	>
		<el-option v-for="item in optionsRef" :key="item.value" :label="item.label" :value="item.value" />
	</el-select>
</template>

<script setup lang="ts">
	import { getDictTypes } from '@/api/dict/data';

	interface Props {
		typeKey: string;
		modelValue: (string | number)[] | string;
		multiple?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {});

	const emit = defineEmits(['update:modelValue', 'onSelect']);

	// 选中的ids
	const checkIds = computed({
		get() {
			return props.modelValue || [];
		},
		set(val) {
			emit('update:modelValue', val);
		},
	});

	// 数据源 带有label、value的数组
	const optionsRef = ref<any[]>([]);

	// 选中的带有label、value的数组
	const checkValue = ref<any[]>([]);

	const onDelete = (e) => {
		checkIds.value = checkIds.value.filter((i) => i !== e);
		checkValue.value = checkValue.value.filter((i) => i.value !== e);
	};

	const onSelect = (e) => {
		checkIds.value = e;
		refreshCheckValue(e);
		emit('onSelect', e);
	};

	const refreshCheckValue = (checkIds) => {
		const list = optionsRef.value.filter((i) => checkIds.includes(i.value));
		checkValue.value = list;
	};
	const refresh = async () => {
		const res = await getDictTypes(props.typeKey);
		optionsRef.value = res;
		refreshCheckValue(checkIds.value);
	};
	refresh();
	watch(
		() => props.typeKey,
		() => {
			refresh();
		},
	);
	defineExpose({ checkRows: checkValue });
</script>

<style lang="scss" scoped></style>
